//local import
import { TenantModel } from '@core/data';
import { ObservableProperty } from '@shared/data/models';

export class TenantStateChangedMessage {
  public tenants: ObservableProperty<TenantModel[]>

  constructor(tenants: ObservableProperty<TenantModel[]>) {
    this.tenants = tenants;
  }
}
